var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterviewLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 401,
    height: 392,
    viewBox: "0 0 401 392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_56623_22356)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_56623_22356)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 72.4424,
    width: 326.422,
    height: 314.914,
    rx: 14.1023,
    transform: "rotate(-12.1033 8 72.4424)",
    fill: "#DCE4EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.41864,
    y: 72.7132,
    width: 325.717,
    height: 314.209,
    rx: 13.7497,
    transform: "rotate(-12.1033 8.41864 72.7132)",
    stroke: "#DADADB",
    strokeWidth: 0.705113
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.41413,
    y: 0.271735,
    width: 179.657,
    height: 11.9969,
    rx: 5.99846,
    transform: "matrix(0.977771 -0.209674 0.196875 0.980429 130.854 67.3539)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.705113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.41266,
    y: 0.272027,
    width: 77.1992,
    height: 23.2619,
    rx: 11.631,
    transform: "matrix(0.977771 -0.209674 0.192706 0.981257 38.5818 87.1407)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.705113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.41266,
    y: 0.272027,
    width: 77.1992,
    height: 23.2619,
    rx: 11.631,
    transform: "matrix(0.977771 -0.209674 0.192706 0.981257 45.6833 120.258)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.705113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.41266,
    y: 0.272027,
    width: 77.1992,
    height: 23.2619,
    rx: 11.631,
    transform: "matrix(0.977771 -0.209674 0.192706 0.981257 52.7849 153.375)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.705113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.41266,
    y: 0.272027,
    width: 77.1992,
    height: 23.2619,
    rx: 11.631,
    transform: "matrix(0.977771 -0.209674 0.192706 0.981257 59.8864 186.493)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.705113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.41266,
    y: 0.272027,
    width: 77.1992,
    height: 23.2619,
    rx: 11.631,
    transform: "matrix(0.977771 -0.209674 0.192706 0.981257 66.988 219.61)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.705113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.41266,
    y: 0.272027,
    width: 77.1992,
    height: 23.2619,
    rx: 11.631,
    transform: "matrix(0.977771 -0.209674 0.192706 0.981257 74.0896 252.727)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.705113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.41413,
    y: 0.271735,
    width: 179.657,
    height: 11.9969,
    rx: 5.99846,
    transform: "matrix(0.977771 -0.209674 0.196875 0.980429 141.651 117.692)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.705113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.41413,
    y: 0.271735,
    width: 179.657,
    height: 11.9969,
    rx: 5.99846,
    transform: "matrix(0.977771 -0.209674 0.196875 0.980429 153.299 172.019)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.705113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.41413,
    y: 0.271735,
    width: 179.657,
    height: 11.9969,
    rx: 5.99846,
    transform: "matrix(0.977771 -0.209674 0.196875 0.980429 165.366 228.275)",
    fill: "#C5D0DE",
    stroke: "#E8F1FA",
    strokeWidth: 0.705113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.41413,
    y: 0.271735,
    width: 179.657,
    height: 11.9969,
    rx: 5.99846,
    transform: "matrix(0.977771 -0.209674 0.196875 0.980429 173.749 267.386)",
    fill: "#C5D0DE",
    stroke: "#E8F1FA",
    strokeWidth: 0.705113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.41413,
    y: 0.271735,
    width: 116.63,
    height: 11.9969,
    rx: 5.99846,
    transform: "matrix(0.977771 -0.209674 0.196875 0.980429 134.538 84.5233)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.705113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.41413,
    y: 0.271735,
    width: 116.63,
    height: 11.9969,
    rx: 5.99846,
    transform: "matrix(0.977771 -0.209674 0.196875 0.980429 145.331 134.855)",
    fill: "#C5D0DE",
    stroke: "#C5D0DE",
    strokeWidth: 0.705113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.41413,
    y: 0.271735,
    width: 116.63,
    height: 11.9969,
    rx: 5.99846,
    transform: "matrix(0.977771 -0.209674 0.196875 0.980429 156.983 189.195)",
    fill: "#C5D0DE",
    stroke: "#E8F1FA",
    strokeWidth: 0.705113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.41413,
    y: 0.271735,
    width: 116.63,
    height: 11.9969,
    rx: 5.99846,
    transform: "matrix(0.977771 -0.209674 0.196875 0.980429 169.046 245.437)",
    fill: "#C5D0DE",
    stroke: "#E8F1FA",
    strokeWidth: 0.705113
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.41413,
    y: 0.271735,
    width: 116.63,
    height: 11.9969,
    rx: 5.99846,
    transform: "matrix(0.977771 -0.209674 0.196875 0.980429 177.432 284.548)",
    fill: "#C5D0DE",
    stroke: "#E8F1FA",
    strokeWidth: 0.705113
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_56623_22356",
    x: 0.846047,
    y: 0.763879,
    width: 399.503,
    height: 390.664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.91783
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.89729
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_56623_22356"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_56623_22356",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_56623_22356",
    x: 0.846047,
    y: 0.763879,
    width: 399.503,
    height: 390.664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.91783
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.89729
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_56623_22356"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_56623_22356",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewLoading);
export default __webpack_public_path__ + "static/media/interview-loading.2d57b0e18c6c34aaa355e8bc95591039.svg";
export { ForwardRef as ReactComponent };